export enum TipoInventarioArquivo {
    CADASTRO_PRODUTOS = 'Cadastro de Produtos'
}